// firebaseConfig.js
import { initializeApp } from "firebase/app";
import { 
  getAuth, 
  GoogleAuthProvider, 
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail
} from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore, enableIndexedDbPersistence } from "firebase/firestore";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAbt-vQi7hLZaFfvGoeylN9Z8lqqtmZa8I",
  authDomain: "duxbyte.firebaseapp.com",
  projectId: "duxbyte",
  storageBucket: "duxbyte.appspot.com",
  messagingSenderId: "269020773438",
  appId: "1:269020773438:web:277e2728012d7fe7af256f",
  measurementId: "G-SPLDNM9CKY"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const storage = getStorage(app);
const db = getFirestore(app);
const messaging = getMessaging(app);

// Activar persistencia offline (IndexedDB)
enableIndexedDbPersistence(db).catch((err) => {
  if (err.code === 'failed-precondition') {
    console.warn('Persistencia solo puede estar activa en una pestaña a la vez');
  } else if (err.code === 'unimplemented') {
    console.warn('Este navegador no soporta la persistencia offline');
  }
});

export {
  app,
  auth,
  googleProvider,
  storage,
  db,
  messaging,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  getToken,
  onMessage
};
